<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RpPgn2/tc-custom/9781611528428.jpg?1718251157455" alt="This image is the cover for the book It's Not Yule, It's Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">It's Not Yule, It's Me
      </h1>
      <p class="bookDescription body article font2">
        <p>Shannon hates Christmas. Mostly because Christmas hates him. It sure seems like it, anyway: every crummy thing that’s happened to him since high school has befallen him at the Most Wonderful Time of the Year. Every humiliating break-up, every high-rise hotel fire -- heck, a few years back, one guy he had the hots for up and died.<br/><br/>Which goes a long way toward explaining why he’s a whimpering mess when he meets Ben the barista one Christmas morning at his neighborhood coffee house. It doesn’t completely excuse his using Ben’s T-shirt as a handkerchief -- while Ben’s still in it -- but Ben’s nothing if not a good sport.<br/><br/>Ben’s such a bright spot that after a while Shannon wonders if maybe his Christmas Curse hasn’t been lifted. And what better place to test this theory than at Ben’s family festivities? It’s not like Christmas is <i>actually</i> cursed. Is it?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael P. Thomas
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?630c29b8